import "./Range.scss";
function Range(props) {
	const handleChange = (e) => {
		props.func(e);
	};
	return (
		<input
			type='range'
			id='volume'
			name='volume'
			min='1'
			max='1.75'
			step={0.25}
			defaultValue={props.currentValue}
			onChange={handleChange}
		/>
	);
}

export default Range;
